import React, {useContext, useMemo} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import NavLink from "../reusable/components/NavLink/NavLink"
import {filterUrl} from "../filter/FilterUrl"
import urlParams from "../../utility/UrlParams"
import DataContext from "../../context/DataContext"
import {getMenuTitles} from "../../utility/Helper"

type Props = {
	links?:{id: number, label:string, href:string}[]
}

function EmptyWishListLinks() {
	const {t} = useTranslation()
	const {collections, brands} = useContext(DataContext)

	const brandsForFooter = brands?.filter(({fields}) => fields?.addToFooter)
	const menuTitles = useMemo(() => getMenuTitles(collections, brandsForFooter), [collections, brandsForFooter])
	return (
		<div style={{maxWidth: "636px", padding: "16px 24px", borderRadius: "16px", background: "#F8F8F8", rowGap: "16px"}}
			className="d-none d-md-flex col-12 flex-column align-items-start justify-content-start">
			<div style={{columnGap: "16px"}}
				className="d-flex align-items-center justify-content-start">
				<img src="/assets/icons/wishList/bike-frame.svg"
					alt="Bike frame" />
				<Typography variant="bodySmBold"
					style={{fontSize: "16px", lineHeight: "24px"}}>{t("product-categories")}</Typography>
			</div>
			<Typography variant="bodySm"
				style={{fontSize: "14px", lineHeight: "20px"}}>{t("choose-a-category-label")}</Typography>
			<div className="d-flex flex-wrap justify-content-start align-items-center ">

				{menuTitles.mobile[0].items?.map(({name, href}, id) => <NavLink className="col-6 pb-3"
					isNewLinkDesign
					key={id}
					href={filterUrl({[urlParams.categories]: href.slice(1)}, urlParams.categories, href.slice(1))}
					label={t(name)}/>)}
			</div>
		</div>
	)
}

export default EmptyWishListLinks
